import React from 'react';
import styled from 'styled-components';
import Functions from '@client/style/Functions';
import FilteredListContent from './FilteredListContent';
import FilteredListToolbar from './FilteredListToolbar';

const Container = styled.div<{ bgColor?: string }>`
	width: 100%;

	background-color: ${props => props.bgColor};

	&:has(+ .BreakerModule) {
		padding-bottom: var(--breaker-total);
	}
`;

const ListsContainer = styled.div`
	padding: 0px var(--gridMargin);
	padding-bottom: 100px;
	/* max-width: 100%; */
	width: 100%;
`;

export default function FilteredList({
	contents,
	allowListView,
	data,
}: {
	contents: any[];
	allowListView?: boolean;
	data: {
		useLocationFilter: boolean;
		useTagFilter: boolean;
		useDateFilter: boolean;
		backgroundColorLink: any;
		detailedThumbnail: boolean;
		detailedThumbnailWithTimestamp: boolean;
		noMatchesText: string;
	};
}) {
	return (
		<Container
			bgColor={data.backgroundColorLink && Functions.hexFromRGB(data.backgroundColorLink?.color)}
			className='colorWrapperAnimatedModule'
		>
			<FilteredListToolbar
				allowListView={allowListView}
				useDateFilter={data.useDateFilter}
				useTagFilter={data.useTagFilter}
				useLocationFilter={data.useLocationFilter}
				backgroundColorLink={data.backgroundColorLink}
			/>
			<ListsContainer>
				<FilteredListContent
					contents={contents}
					detailedThumbnail={data.detailedThumbnail}
					detailedThumbnailWithTimestamp={data.detailedThumbnailWithTimestamp}
					noMatchesText={data.noMatchesText}
					backgroundColorLink={data.backgroundColorLink}
				/>
			</ListsContainer>
		</Container>
	);
}
